import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { getTranslation } from '../../providers/TranslationProvider';
import Icon from '../Icon';
import Spacer from '../Spacer';
import CheckMark from '../../svg/icons/ic_checkmark-success_20x20.svg';
import NotifyBell from '../../svg/icons/ic_notify-circle_20x20.svg';
import { CONSTANTS } from './notifyUtils';
import { sanitizeString } from '../../utils/sanitizeString';

const NotifyPostStateHeader = ({ context, isGda, notifyFlowState }) => {
  const { SET_NOTIFY_SUCCESS, TABLES_AVAILABLE } = CONSTANTS;
  const accountPageUrl = 'account/reservations-and-notify';
  const accountPageRoute = `/${context === 'widget' ? '#/' : ''}${accountPageUrl}`;
  const accountPageMessage = getTranslation({
    translationKey: 'manage_notify_in_account',
    translationValues: { accountPageRoute },
    fallback: `You can manage your Notify in your <a href="${accountPageRoute}">Account</a>.`,
  });
  const sanitizedAccountPageMessage = sanitizeString(accountPageMessage);

  const flowStateProps = {
    [SET_NOTIFY_SUCCESS]: {
      wrapperClass: cx('Notify__success', { 'Notify__success-isGda': isGda }),
      headerClass: 'Notify__success-title',
      header: getTranslation({
        translationKey: isGda ? 'priority_notify_on' : 'notify_on',
        fallback: isGda ? 'Priority Notify On' : 'Notify On',
      }),
      iconComponent: CheckMark,
      iconName: 'checkmark',
      isAccountPage: window.location.hash.includes(accountPageUrl)
        || window.location.pathname.includes(accountPageUrl),
    },
    [TABLES_AVAILABLE]: {
      wrapperClass: 'Notify__available',
      headerClass: '',
      header: getTranslation({ translationKey: 'tables_available', fallback: 'Tables Available!' }),
      iconComponent: NotifyBell,
      iconName: 'bell',
      isAccountPage: false,
    },
  };

  const {
    wrapperClass,
    headerClass,
    header,
    iconComponent,
    iconName,
    isAccountPage,
  } = flowStateProps[notifyFlowState];

  return (
    <div className="Notify__head">
      <div className={wrapperClass}>
        <h2 className={headerClass}>{header}</h2>
        <Spacer width="5" />
        <Icon component={iconComponent} name={iconName} />
      </div>
      {!isAccountPage && (
        <div className="Notify__manage-message" dangerouslySetInnerHTML={{ __html: sanitizedAccountPageMessage }} />
      )}
    </div>
  );
};

NotifyPostStateHeader.propTypes = {
  context: PropTypes.string,
  isGda: PropTypes.bool,
  notifyFlowState: PropTypes.string.isRequired,
};

NotifyPostStateHeader.defaultProps = {
  context: undefined,
  isGda: undefined,
};

export default NotifyPostStateHeader;
